'use client';

import Script from 'next/script';
import useCspNonce from '@/hooks/useCspNonce';
import { isProduction } from '@/utils/constants';

// WARNING: only to be used inside layout.tsx
//
// `afterInteractive` (not `beforeInteractive`): the nonce is read from the
// meta tag on the client, and beforeInteractive scripts are scheduled before
// hydration — too early for a client-read nonce. The explicit `nonce` prop
// is required because some browsers (Samsung Internet <=7.x, older Android
// WebView) don't propagate nonces through `document.currentScript`.
//
// Consent-ordering is preserved by GoogleConsentModeDefaultsScript (still
// `beforeInteractive`), which pins the default-denied state and sets
// `wait_for_update: 500` — covering the Usercentrics loader boot window so
// GTM doesn't tick with a stale consent signal.
export default function UsercentricsScript() {
  const nonce = useCspNonce();

  if (!isProduction) return null;
  if (!nonce) return null;

  return (
    <Script
      id="usercentrics-cmp"
      data-ruleset-id="lnrjhV3MONuu7l"
      strategy="afterInteractive"
      src="https://web.cmp.usercentrics.eu/ui/loader.js"
      nonce={nonce}
    />
  );
}
